import { render, staticRenderFns } from "./PieRingShiYong.vue?vue&type=template&id=4b8969e9&scoped=true"
import script from "./PieRingShiYong.vue?vue&type=script&lang=js"
export * from "./PieRingShiYong.vue?vue&type=script&lang=js"
import style0 from "./PieRingShiYong.vue?vue&type=style&index=0&id=4b8969e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8969e9",
  null
  
)

export default component.exports